import React from 'react';

function Contact() {
  return (
    <section style={{background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', minHeight: '100vh', padding: '160px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#0c4a6e', fontWeight: 900, marginBottom: '20px'}}>Get In Touch</h2>
          <p style={{fontSize: '1.4rem', color: '#0369a1', maxWidth: '800px', margin: '0 auto'}}>We'd love to hear from you. Reach out to us anytime!</p>
        </div>

        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{background: 'white', padding: '40px', borderRadius: '25px', boxShadow: '0 15px 40px rgba(0,0,0,0.1)', marginBottom: '30px'}}>
            <h3 style={{fontSize: '2rem', color: '#0c4a6e', marginBottom: '30px', fontWeight: 800}}>Contact Information</h3>
            
            <div style={{marginBottom: '30px', display: 'flex', alignItems: 'start', gap: '20px'}}>
              <div style={{background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', width: '60px', height: '60px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                <i className="fas fa-map-marker-alt" style={{color: 'white', fontSize: '1.8rem'}}></i>
              </div>
              <div>
                <h4 style={{fontSize: '1.3rem', color: '#0c4a6e', marginBottom: '8px', fontWeight: 700}}>Address</h4>
                <p style={{fontSize: '1.05rem', color: '#64748b', lineHeight: 1.6}}>Tunga St, Vijinapura, Dooravani Nagar, Bengaluru, Karnataka 560016</p>
              </div>
            </div>

            <div style={{marginBottom: '30px', display: 'flex', alignItems: 'start', gap: '20px'}}>
              <div style={{background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', width: '60px', height: '60px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                <i className="fas fa-phone" style={{color: 'white', fontSize: '1.8rem'}}></i>
              </div>
              <div>
                <h4 style={{fontSize: '1.3rem', color: '#0c4a6e', marginBottom: '8px', fontWeight: 700}}>Phone</h4>
                <a href="tel:08025658866" style={{fontSize: '1.05rem', color: '#0891b2', textDecoration: 'none', fontWeight: 600, display: 'block', marginBottom: '5px'}}>080-25658866</a>
                <a href="tel:+919343797558" style={{fontSize: '1.05rem', color: '#0891b2', textDecoration: 'none', fontWeight: 600, display: 'block', marginBottom: '5px'}}>+91 93437 97558</a>
                <a href="tel:+918884659284" style={{fontSize: '1.05rem', color: '#0891b2', textDecoration: 'none', fontWeight: 600, display: 'block'}}>+91 88846 59284</a>
              </div>
            </div>

            <div style={{marginBottom: '30px', display: 'flex', alignItems: 'start', gap: '20px'}}>
              <div style={{background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', width: '60px', height: '60px', borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                <i className="fas fa-envelope" style={{color: 'white', fontSize: '1.8rem'}}></i>
              </div>
              <div>
                <h4 style={{fontSize: '1.3rem', color: '#0c4a6e', marginBottom: '8px', fontWeight: 700}}>Email</h4>
                <a href="mailto:bethelvijinapura@gmail.com" style={{fontSize: '1.05rem', color: '#7c3aed', textDecoration: 'none', fontWeight: 600}}>bethelvijinapura@gmail.com</a>
              </div>
            </div>

            <div style={{padding: '25px', background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', borderRadius: '15px', color: 'white'}}>
              <h4 style={{color: 'white', marginBottom: '15px', fontSize: '1.3rem', fontWeight: 700}}><i className="fas fa-clock" style={{marginRight: '10px'}}></i>Working Hours</h4>
              <p style={{margin: '8px 0', fontSize: '1.05rem'}}><strong>Mon - Fri:</strong> 8:30 AM - 4:00 PM</p>
              <p style={{margin: '8px 0', fontSize: '1.05rem'}}><strong>Sat:</strong> 8:30 AM - 2:30 PM</p>
            </div>
          </div>

          <div style={{background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', padding: '35px', borderRadius: '25px', border: '3px solid #fbbf24', textAlign: 'center', boxShadow: '0 10px 30px rgba(251, 191, 36, 0.2)', marginBottom: '60px'}}>
            <i className="fas fa-question-circle" style={{fontSize: '3rem', color: '#d97706', marginBottom: '15px'}}></i>
            <h3 style={{color: '#92400e', marginBottom: '15px', fontSize: '1.5rem', fontWeight: 800}}>Have a Query?</h3>
            <p style={{marginBottom: '20px', fontSize: '1.05rem', color: '#78350f'}}>Fill out our enquiry form and we'll get back to you within 24 hours.</p>
            <a
              href="https://forms.google.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white', padding: '15px 35px', borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '1.1rem', display: 'inline-block', boxShadow: '0 8px 20px rgba(217, 119, 6, 0.4)', transition: 'all 0.3s'}}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              Open Enquiry Form
            </a>
          </div>
        </div>

        {/* Map */}
        <div style={{background: 'white', padding: '30px', borderRadius: '25px', boxShadow: '0 15px 40px rgba(0,0,0,0.1)'}}>
          <h3 style={{fontSize: '2rem', color: '#0c4a6e', marginBottom: '25px', fontWeight: 800, textAlign: 'center'}}>Find Us on Map</h3>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.507172739966!2d77.67093487500513!3d13.00334231418163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae113ce0e6c349%3A0xa4cde913d0d2cd5e!2sBethel%20Public%20School!5e0!3m2!1sen!2sin!4v1769256529647!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{border: 0, borderRadius: '20px', boxShadow: '0 5px 20px rgba(0,0,0,0.1)'}}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="School Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default Contact;
